/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { MoreDropDown, RoutedModal } from "../../../common";
import { POSendEmail } from "../POSendEmail";
import { usePOShareDialog } from "../POShareDialog/usePOShareDialog";

export const POExtra = ({ PODetails = {}, btnStyles = {} }) => {
  const [isSendEmail, setIsSendEmail] = useState(false);
  const { handleDownloadPO } = usePOShareDialog({});

  return (
    <>
      <MoreDropDown btnStyles={btnStyles}>
        <a
          className="cursor-pointer"
          onClick={() => handleDownloadPO(PODetails)}
        >
          Download PO
        </a>
        <hr />
        <a className="cursor-pointer" onClick={() => setIsSendEmail(true)}>
          Send PO
        </a>
      </MoreDropDown>

      <RoutedModal
        width={550}
        leftHeaderSide={<h4>Send P.O to supplier</h4>}
        isActive={isSendEmail}
        closeModal={() => setIsSendEmail(false)}
        style={{ height: "auto" }}
      >
        <POSendEmail
          pODetails={PODetails}
          closeModal={() => setIsSendEmail(false)}
        />
      </RoutedModal>
    </>
  );
};
